<div class="modal-container">
  <div class="modal-header">
    <h3>Add new agent</h3>
    <button type="button" class="modal-close" aria-label="Close" (click)="close()">
      <span class="material-icons" translate="no">close</span>
    </button>
  </div>

  <div class="modal-body">
    <form class="bot-form" [formGroup]="newBotForm" (ngSubmit)="addNewItem()">
      <div class="form-field-container">
        <label for="bot-name" class="form-field-label">Agent name *</label>
        <mat-form-field class="gingr-input-wrapper compact-field w-full" appearance="outline" subscriptSizing="dynamic">
          <input id="bot-name" matInput placeholder="Enter agent name" type="text" formControlName="name" />
          @if (name.invalid && name.touched) {
            <mat-error>Agent name is required</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-field-container">
        <label for="bot-model" class="form-field-label">Agent model *</label>
        <mat-form-field class="gingr-input-wrapper compact-field w-full" appearance="outline" subscriptSizing="dynamic">
          <mat-select id="bot-model" formControlName="botModel" placeholder="Select a model">
            @for (model of botsModels; track model) {
              <mat-option [value]="model.id">{{ model.name }}</mat-option>
            }
          </mat-select>
          @if (botModel.invalid && botModel.touched) {
            <mat-error>Agent model is required</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-field-container">
        <label for="bot-type" class="form-field-label">Agent type *</label>
        <mat-form-field class="gingr-input-wrapper compact-field w-full" appearance="outline" subscriptSizing="dynamic">
          <mat-select id="bot-type" formControlName="botType" placeholder="Select a type">
            @for (type of botTypes; track type) {
              <mat-option [value]="type.id">{{ type.name }}</mat-option>
            }
          </mat-select>
          @if (botType.invalid && botType.touched) {
            <mat-error>Agent type is required</mat-error>
          }
        </mat-form-field>
      </div>

      @if (isPredefinedBotType()) {
        <div class="form-field-container">
          <label for="bot-status" class="form-field-label">Status *</label>
          <mat-form-field class="gingr-input-wrapper compact-field w-full" appearance="outline" subscriptSizing="dynamic">
            <mat-select id="bot-status" formControlName="status" placeholder="Select status">
              @for (st of statuses; track st) {
                <mat-option [value]="st">{{ st | titlecase }}</mat-option>
              }
            </mat-select>
            @if (status.invalid && status.touched) {
              <mat-error>Status is required</mat-error>
            }
          </mat-form-field>
        </div>
      }

      @if (botType.value === 'botCreator') {
        <div class="form-field-container">
          <label for="bot-language" class="form-field-label">Language *</label>
          <mat-form-field class="gingr-input-wrapper compact-field w-full" appearance="outline" subscriptSizing="dynamic">
            <mat-select id="bot-language" formControlName="language" placeholder="Select language">
              @for (language of languages; track language) {
                <mat-option [value]="language.code">{{ language.name }}</mat-option>
              }
            </mat-select>
            @if (language.invalid && language.touched) {
              <mat-error>Language is required</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-field-container">
          <label for="bot-description" class="form-field-label">Description</label>
          <mat-form-field class="gingr-input-wrapper compact-field w-full" appearance="outline" subscriptSizing="dynamic">
            <input id="bot-description" matInput placeholder="Brief description of the agent" type="text" formControlName="description" />
          </mat-form-field>
        </div>

        <div class="form-field-container">
          <label for="bot-instruction" class="form-field-label">Instruction</label>
          <mat-form-field class="gingr-input-wrapper compact-field w-full" appearance="outline" subscriptSizing="dynamic">
            <input id="bot-instruction" matInput placeholder="How the agent should behave" type="text" formControlName="instruction" />
          </mat-form-field>
        </div>

        <div class="form-field-container">
          <label for="bot-behaviour" class="form-field-label">Behaviour</label>
          <mat-form-field class="gingr-input-wrapper compact-field w-full" appearance="outline" subscriptSizing="dynamic">
            <input id="bot-behaviour" matInput placeholder="Personality and tone guidelines" type="text" formControlName="behaviour" />
          </mat-form-field>
        </div>
      }
    </form>
  </div>

  <div class="modal-footer">
    <button mat-stroked-button type="button" class="action-btn" (click)="close()">Cancel</button>
    <button
      mat-raised-button
      color="accent"
      type="button"
      class="action-btn"
      [disabled]="!!newBotForm.invalid"
      (click)="addNewItem()"
    >
      Create agent
    </button>
  </div>
</div>
